import { Chip } from "@mui/material";

// ----------------------------------------------------------------------

type Props = {
	value: string;
};

export const NumberChip = ({ value }: Props) => {
	return (
		<Chip
			label={value}
			size={"small"}
			sx={{
				py: 1,
				px: 0.21,
				backgroundColor: "primary.lighter",
				color: "primary.dark",
				fontSize: 12
			}}
		/>
	);
};

export default NumberChip;
